var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout flex"},[_c('div',{staticClass:"menu"},[_c('Menu')],1),_c('div',{class:['nav', _vm.menuSwitch ? 'menu-ani-open1' : 'menu-ani-close1']},[_c('Header'),_c('div',{staticClass:"pageContainer"},[_c('div',{staticClass:"pageTab scrollbar-x"},[_c('PageTab')],1),_c('div',{staticClass:"content"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }